import { TeamInvitation } from '../models';
import { TeamRepository } from '../repositories';

export class GetTeamInvitationsUseCase {
  constructor(private teamRepository: TeamRepository) {}

  async execute(userId: string): Promise<{
    received: TeamInvitation[];
    sent: TeamInvitation[];
  }> {
    const [received, sent] = await Promise.all([
      this.teamRepository.getInvitationsReceived(userId),
      this.teamRepository.getInvitationsSent(userId),
    ]);
    return { received, sent };
  }
}
